<template>
  <swiper class="home-swiper" >
    <swiper-item v-for="item in cbanners" :key="item.acm" >
      <!-- <a :href="item.link"> -->
	  <div class="index-swiper">
        <img :src="item.image" alt="" @load="imageLoad">
		<!-- <p>{{item.content}}</p> -->
		  
	  </div>
      <!-- </a> -->
    </swiper-item>
  </swiper>
</template>

<script>
  import {Swiper, SwiperItem} from 'components/common/swiper';
  export default {
    name: "HomeSwiper",
    data(){
      return {
        isLoad: false
      }
    },
    props: {
        cbanners:{
            type:Array,
            default() {
                return []
            }
        }
    },
    components:{
        Swiper,SwiperItem
    },
    methods: {
      imageLoad(){
       if(!this.isLoad){
         this.$emit("swiperImageLoad")
         this.isLoad = true;
       }
      }
    }
  }
</script>

<style scoped>
	.home-swiper{  
		position: relative;
		height: 100vh;
		background-color: #fff;
		background-size: cover;
	}
	.home-swiper .swiper{
		height: 100vh;
	}
	.home-swiper .swiper .slide{
		height: 100vh;
	}
	.index-swiper{
		overflow: hidden;
		position: relative;
		justify-content: center!important;
	}
	.index-swiper p{
		font-size: 30px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #FFFFFF;
		position: absolute;
		top: 50%;
		
	}
	.index-swiper img{
		width: 100%;
		height: 100vh;
		object-fit: cover;
	}
	.home-swiper /deep/ .indicator{
		bottom: 191px;
	}
	
	.home-swiper /deep/ .indi-item{
		width: 40px;
		height: 4px;
		background: #FAFAFA;
		opacity: 0.56;
		border-radius: 2px;

	}
	.home-swiper /deep/ .indi-item.active{
		background: #FAFAFA;
		opacity: 1;
	}

</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		
	}
	@media only screen and (min-width:768px) and (max-width:991px) {
		
	}
	@media (max-width:767px) {
		.home-swiper{
			position: relative;
			height: 410px;
			background-color: #fff;
			background-size: cover;
		}
		.home-swiper .swiper{
			height: 410px;
		}
		.home-swiper .swiper .slide{
			height: 410px;
		}
		.home-swiper /deep/ .indicator{
			bottom: 270px;
		}
		.index-swiper img{
			height: 410px;
		}
		
	}
</style>

